import Handlebars, { log } from 'handlebars';
import toastr from 'toastr';
import linkify from 'linkify';
import Settings from '~/settings.js';

import EventHub from '~/eventHub';
import template from '~/templates/report.handlebars';
import report_template from '~/templates/report-details.handlebars';
import customreport_template from '~/templates/report-detailscustom.handlebars';
import customreportdata_template from '~/templates/customreportsfields/customreportdata.handlebars';
import customreportfiles_template from '~/templates/customreportsfields/customreportfiles.handlebars';
import collaborators_template from '~/templates/collaborators.handlebars';
import changesubcat_template from '~/templates/changesubcat.handlebars';
import getReportCommentsService from '~/services/reportCommentsService';
import getAdminNoteService from '~/services/adminnotesService';
import getFileService from '~/services/fileService';
import getAdminFileService from '~/services/adminfileService';
import getReportCommentsFileService from '~/services/reportCommentsFileService';
import getReasonOfChangeService from '~/services/reportReasonforChangeStatusService';
import imageResize from '~/services/imageResizeService';
import GeneralView from '~/generalView';
import PrevisualView from '~/views/previsualView';
import getUtilsService from '~/services/utilsService';

var ReportView = GeneralView.View.extend({
	className: 'report-details-view',
	reportid: '',
	userid: '',
	report: null,
	files: [],
	adminnotes: null,
	adminoteid: null,
	fileIndex: 0,
	filescont: 0,
	adminCommentFiles: [],
	adminCommentFilesCont: 0,
	currentReportFilesCount: 0,
	varcomments: false,
	remCollaborators: null,
	adminNoteLimit: 728,
	statusvar: 0,
	assignvar: 0,
	subCatId: '',
	deleted: null,

	/**
	* @constructor
	*/
	initialize: function() {
		toastr.options = {
			"closeButton": true,
			"debug": false,
			"newestOnTop": true,
			"progressBar": false,
			"positionClass": "toast-top-center",
			"preventDuplicates": false,
			"onclick": null,
			"showDuration": "300",
			"hideDuration": "1000",
			"timeOut": "5000",
			"extendedTimeOut": "1000",
			"showEasing": "swing",
			"hideEasing": "linear",
			"showMethod": "fadeIn",
			"hideMethod": "fadeOut"
		}
	},

	events: {
		'click #btntogglecomments': 'commentsOpenClose',
		'click #btntogglecommentsmuni': 'commentsmuniOpenClose',
		'click #do-comment': 'savecomment',
		'click #saveadminnote': 'saveadminnote',
		'click #saveachangestatus': 'changestatus',
		'click #assign': 'assign',
		'change #priorities': 'priority',
		'change #upload' : 'uploadFile',
		'change #upload2' : 'uploadFile2',
		'change #upload3' : 'uploadFile3',
		'click .discardreport' : 'discardfile',
		'click .discardreport3' : 'discardfile3',
		'click .SaveFilesbtn' : 'SaveFiles',
		'click .notefilesbtn' : 'filesmodal',
		'keyup #text-adminnote' : 'btnfiles',
		'click #adminnotesmodal' : 'openmodaladminnotes',
		'change #state' : 'changestatusfunc',
		'click #collabmodalopen' : 'openmodalcollaborators',
		'click .markUser' : 'markUser',
		'click .add-collaborator' : 'addCollaborator',
		'click .rm-collaborator' : 'removeCollaborator',
		'click .mark-all' : 'markAll',
		'click .mark-none' : 'markNone',
		'click .file' : 'previsual',
		'click .btnrenderbitacfiles' : 'renderFiles',
		'click .file_download' : 'downloadFile',
		'click .see-more' : 'showCompleteAdminNote',
		'click .reportstatusbtncontainer' : 'showstatusselect',
		'click .reportasignbtncontainer' : 'showsassignselect',
		'click .bitacorabtncontainer' : 'clearAdminNoteModal',
		'click #changesubcatopen' : 'openmodalchangesubcat',
		'click #prorrogaactivate' : 'activateProrroga',
		'change .supercats' : 'changesupercat',
		'change .subcats' : 'changesubcat',
		'click #savechangesubcat' : 'savechangesubcat',
	},

	/**
	*
	* @function render
	* @return {ReportView}
	*/
	render: function() {
		this.$el.html(Handlebars.template(template));
		this.$reportDisplay = this.$('.report_display');
		this.listenTo(EventHub, 'report:setState', data => {
			if (data.reportID) {
				this.renderReport(data.reportID);
			}
			else {
				this.$reportDisplay.empty();
			}
		});
		return this;
	},

	showstatusselect: function(){
		var stateselect=$("#state");
		if (this.statusvar == 1) {
			var stateselect=$("#state");
			stateselect.attr('size',0);
			this.statusvar = 0;
		}else {
			var length = $('#state> option').length;
			stateselect.attr('size',length);
			this.statusvar = 1;
		}
	},

	showsassignselect: function(){
		var assignselect=$("#priorities");
		if (this.assignvarvar == 1) {
			var assignselect=$("#priorities");
			assignselect.attr('size',0);
			this.assignvarvar = 0;
		}else {
			var length = $('#priorities> option').length;
			assignselect.attr('size',length);
			this.assignvarvar = 1;
		}
	},

	openmodaladminnotes: function(){
		this.filescont = 0;
		$('#newfiles').prop('disabled', true);
		$('#saveadminnote').prop('disabled', true);
		$('.notefilesbtn').prop('disabled', false);
		$('.discardreport').empty();
		$('#loadfilestext').hide();
		$('#loadfilesspin').hide();
		$('#text-adminnote').val(null);
		this.files = [];
	},

	btnfiles: function(){
		var adminnote = this.$el.find('#text-adminnote').val();
		var state = false;
		if (adminnote == '') {
			state = true;
		}
		$('#newfiles').prop('disabled', state);
		$('#saveadminnote').prop('disabled', state);
		$('.notefilesbtn').prop('disabled', !state);
	},

	openmodalchangesubcat: function(){
		var subCatId = this.report[0].attributes.subCategory.id;
		this.subCatId = subCatId;
		var superCatId = this.report[0].attributes.subCategory.attributes.superCat.id;
		$('#catspicker').html('');
		$('#subcatspicker').html('');
		$('#savechangesubcat').prop('disabled', true);
		Parse.Cloud.run("getsupercategories").then(function(result) {
			for(var i = 0; i < result.length; ++i){
				if(result[i].id == superCatId){
					$('#catspicker').append('<div class="pickCat""><input type="radio" class="supercats" name="superCats" value="'+result[i].id+'" checked><label>'+result[i].attributes.name+'</label></div>');
				}
				else{
					$('#catspicker').append('<div class="pickCat""><input type="radio" class="supercats" name="superCats" value="'+result[i].id+'"><label>'+result[i].attributes.name+'</label></div>');
				}
			}
		},
		function(error) {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
		Parse.Cloud.run("getsubcategories", { superCatId: superCatId }).then(function(result) {
			for(var i = 0; i < result.length; ++i){
				if(result[i].id == subCatId){
					$('#subcatspicker').append('<div class="pickCat""><input type="radio" class="subcats" name="subCats" value="'+result[i].id+'" checked><label>'+result[i].attributes.name+'</label></div>');
				}
				else{
					$('#subcatspicker').append('<div class="pickCat""><input type="radio" class="subcats" name="subCats" value="'+result[i].id+'"><label>'+result[i].attributes.name+'</label></div>');
				}
			}
		},
		function(error) {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},

	activateProrroga: function(){
		console.log('test');
		var that = this;
		Parse.Cloud.run("ActivateProrroga", { reportID: this.reportid }).then(function(response) {
			toastr.success(arrlang[lang]["SaveStateok"],"Operación realizada");
			that.renderReport(that.reportid);
		},
		function(error) {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},

	changesupercat: function(e){
		var superCatId = e.currentTarget.value;
		$('#subcatspicker').html('');
		$('#savechangesubcat').prop('disabled', true);
		Parse.Cloud.run("getsubcategories", { superCatId: superCatId }).then(function(result) {
			for(var i = 0; i < result.length; ++i){
				$('#subcatspicker').append('<div class="pickCat""><input type="radio" class="subcats" name="subCats" value="'+result[i].id+'"><label>'+result[i].attributes.name+'</label></div>');
			}
		},
		function(error) {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},

	changesubcat: function(e){
		var subCatId = e.currentTarget.value;
		this.subCatId = subCatId;
		if($('.supercats').is(':checked') && $('.subcats').is(':checked')){
			$('#savechangesubcat').prop('disabled', false);
		}
	},

	savechangesubcat: function(){
		if($('.supercats').is(':checked') && $('.subcats').is(':checked')){
			$('#savechangesubcat').prop('disabled', true);
			var that = this;
			Parse.Cloud.run("ChangeSubCat", { reportID: this.reportid, subCatID: this.subCatId }).then(function(result) {
				that.renderReport(that.reportid);
				$('.modal-backdrop').remove();
				toastr.success(arrlang[lang]['ChangeSubCatSucess'],"Operación realizada");
			},
			function(error) {
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
					default:
						if(arrlang[lang][error.message]){
							toastr.error(arrlang[lang][error.message], "Error");
						}
						else{
							toastr.error('Reporte no reubicado, hubo un problema con la red.', "Error");	
						}
					break;
				}
			});
		}
	},

	openmodalcollaborators: function(){
		var listElements = $('ul .markUser');
		for(var i = 0; i < listElements.length; ++i){
			listElements[i].classList.remove("selected");
		}
		document.getElementsByClassName("add-collaborator")[0].disabled = true;
		document.getElementsByClassName("rm-collaborator")[0].disabled = true;
		document.getElementsByClassName("mark-none")[0].disabled = true;
		document.getElementsByClassName("mark-none")[1].disabled = true;
		if(this.deleted){
			document.getElementsByClassName("mark-all")[0].disabled = true;
		}
		else{
			document.getElementsByClassName("mark-all")[0].disabled = false;
		}
	},

	markUser: function(e){
		var markElement = e.currentTarget;
		markElement.classList.toggle("selected");
		var listElements = e.currentTarget.parentElement.getElementsByClassName("markUser");
		var buttonsArray = markElement.parentElement.parentElement.previousElementSibling;
		var addCollaborator = buttonsArray.getElementsByClassName("add-collaborator")[0];
		var removeCollaborator = buttonsArray.getElementsByClassName("rm-collaborator")[0];
		var markNone = buttonsArray.getElementsByClassName("mark-none")[0];
		var markAll = buttonsArray.getElementsByClassName("mark-all")[0];
		if(addCollaborator){
			addCollaborator.disabled = false;
		}
		if(removeCollaborator){
			removeCollaborator.disabled = false;
		}
		markNone.disabled = false;
		if(markAll){
			markAll.disabled = false;
		}
		if(markElement.parentElement.getElementsByClassName("selected").length == 0){
			if(addCollaborator){
				addCollaborator.disabled = true;
			}
			if(removeCollaborator){
				removeCollaborator.disabled = true;
			}
			markNone.disabled = true;
		}
		if(markElement.parentElement.getElementsByClassName("selected").length == listElements.length){
			if(markAll){
				markAll.disabled = true;
			}
		}
	},

	setcollabs: function(notCollaborators, collaborators){
		var that = this;
		for(var x = 0; x < notCollaborators.length; ++x){
			if (Settings.shogunmonitorapp && Parse.User.current().attributes.role != 'Administrador General') {
				if (notCollaborators[x].attributes.supercategory == that.user.attributes.supercategory && Settings.shogunmonitorapp && that.user.attributes.supercategory != undefined) {
					$('#notcollaborators').append('<li class="markUser" value="'+notCollaborators[x].id+'"><label>'+notCollaborators[x].attributes.username+'</label></li>');
				}
			}else {
				$('#notcollaborators').append('<li class="markUser" value="'+notCollaborators[x].id+'"><label>'+notCollaborators[x].attributes.username+'</label></li>');
			}
		}
		for(var i = 0; i < collaborators.length; ++i){
			if (Settings.shogunmonitorapp && Parse.User.current().attributes.role != 'Administrador General') {
				if (notCollaborators[x].attributes.supercategory == that.user.attributes.supercategory && Settings.shogunmonitorapp && that.user.attributes.supercategory != undefined) {
					$("#collaborators").append("<li class='markUser' value='"+collaborators[i].id+"'><label>"+collaborators[i].attributes.username+"</label></li>");
				}
			}else {
				$("#collaborators").append("<li class='markUser' value='"+collaborators[i].id+"'><label>"+collaborators[i].attributes.username+"</label></li>");
			}
		}
	},

	addCollaborator: function(e){
		//agregar a la base de datos
		var that = this;
		var listElements = e.currentTarget.parentElement.nextElementSibling.getElementsByClassName("selected");
		var listIds = [];
		for(var i = 0; i < listElements.length; ++i){
			listIds.push(listElements[i].getAttribute("value"));
		}
		var subCatName = this.report[0].attributes.subCategory.attributes.name;
		var superCatName = this.report[0].attributes.subCategory.attributes.superCat.attributes.name;
		Parse.Cloud.run("addCollaborator", { 'reportId': this.reportid, 'listUsers': listIds, 'subCatName':  subCatName, 'superCatName': superCatName }).then(function(result) {
			toastr.success("Colaboradores agregados satisfactoriamente","Operación realizada");
			var permissions = getUtilsService.getprofilepermissions();
			var id =  { reportID: that.reportid, mobile: false};
			if (Settings.shogunmonitorapp && !permissions.accessallreports) {
				id.shogunmonitorapp = true;
			};
			Parse.Cloud.run("GetReport", id).then((reportinfo) => {
				var queryPromise = reportinfo.report[0].attributes.collaborators.query().find();
				Parse.Promise.when(queryPromise).then((collaborators) => {
					var notCollaborators = reportinfo.users;
					for(var i = 0; i < collaborators.length; ++i){
						for(var j = 0; j < notCollaborators.length; ++j){
							if(collaborators[i].id == notCollaborators[j].id){
								notCollaborators.splice(j, 1);
							}
						}
					}
					$("#notcollaborators").html('');
					$("#collaborators").html('');
					that.setcollabs(notCollaborators, collaborators);
				},
				(error) => {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				});
			},
			(error) => {
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
				default:
					if(arrlang[lang][error.message]){
						toastr.error(arrlang[lang][error.message], "Error");
					}
					else{
						toastr.error('Collaborador no asignado, hubo un problema con la red.', "Error");
					}
				break;
			}
		});
		document.getElementsByClassName("add-collaborator")[0].disabled = true;
		document.getElementsByClassName("rm-collaborator")[0].disabled = true;
		document.getElementsByClassName("mark-all")[0].disabled = false;
		document.getElementsByClassName("mark-none")[0].disabled = true;
		document.getElementsByClassName("mark-none")[1].disabled = true;
	},

	removeCollaborator: function(e){
		var that = this;
		var markedElements = e.currentTarget.parentElement.nextElementSibling.getElementsByClassName("selected");
		var listElements = e.currentTarget.parentElement.nextElementSibling.getElementsByClassName("markUser");
		if(markedElements.length == listElements.length){
			this.remCollaborators = e;
			window.spinnerDialog.show();
			toastr.options.timeOut = "0";
			toastr.options.extendedTimeOut = "0";
			toastr.options.closeButton = false;
			toastr.options.tapToDismiss = false;
			var txt = '<span>'+ arrlang[lang]["RemAllCollaboratorsReport"] +'</span><br><button class="btntoastr btnaccept">'+ arrlang[lang]["ToastrAccept"] +'</button><button class="btntoastr btncancel">'+ arrlang[lang]["ToastrCancel"] +'</button>';
			this.toastrButtons(txt, 'warning');
			$('.btnaccept').one("click", function(e){
				that.acceptButtonRemCollaborator(that.remCollaborators);
			});
			$('.btncancel').one("click", function(){
				that.cancelButtonRemCollaborator();
			});
		}
		else{
			this.remCollaborator(e);
		}
	},

	acceptButtonRemCollaborator: function(e){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		toastr.options.closeButton = true;
		toastr.options.tapToDismiss = true;
		window.spinnerDialog.hide();
		toastr.remove();
		this.remCollaborator(e);
	},

	cancelButtonRemCollaborator: function(){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		toastr.options.closeButton = true;
		toastr.options.tapToDismiss = true;
		window.spinnerDialog.hide();
		toastr.remove();
	},

	remCollaborator: function(e){
		//quitar de la base de datos
		var that = this;
		var listElements = e.currentTarget.parentElement.nextElementSibling.getElementsByClassName("selected");
		var listIds = [];
		for(var i = 0; i < listElements.length; ++i){
			listIds.push(listElements[i].getAttribute("value"));
		}
		Parse.Cloud.run("removeCollaborator", { 'reportId': this.reportid, 'listUsers': listIds }).then(function(result) {
			for (var i = 0; i < listIds.length; i++) {
				if (listIds[i] == Parse.User.current().id) {
					$('#collaboratorsModalContainer').hide();
					$('.modal-backdrop').hide();
					toastr.warning(arrlang[lang]['warningmessage'],arrlang[lang]['warning']);
					EventHub.trigger('navigate', 'personal', {
						trigger: true
					});
					currentuser = true ;
				}
			}
			toastr.success("Colaboradores removidos satisfactoriamente","Operación realizada");
			var permissions = getUtilsService.getprofilepermissions();
			var id =  { reportID: that.reportid, mobile: false};
			if (Settings.shogunmonitorapp && !permissions.accessallreports) {
				id.shogunmonitorapp = true;
			};
			Parse.Cloud.run("GetReport", id).then((reportinfo) => {
				var queryPromise = reportinfo.report[0].attributes.collaborators.query().find();
				Parse.Promise.when(queryPromise).then((collaborators) => {
					var notCollaborators = reportinfo.users;
					for(var i = 0; i < collaborators.length; ++i){
						for(var j = 0; j < notCollaborators.length; ++j){
							if(collaborators[i].id == notCollaborators[j].id){
								notCollaborators.splice(j, 1);
							}
						}
					}
					$("#notcollaborators").html('');
					$("#collaborators").html('');
					that.setcollabs(notCollaborators, collaborators);
				},
				(error) => {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				});
			},
			(error) => {
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
				default:
					if(arrlang[lang][error.message]){
						toastr.error(arrlang[lang][error.message], "Error");
					}
					else{
						toastr.error('Collaborador no removido, hubo un problema con la red.', "Error");
					}
				break;
			}
		});
		document.getElementsByClassName("add-collaborator")[0].disabled = true;
		document.getElementsByClassName("rm-collaborator")[0].disabled = true;
		document.getElementsByClassName("mark-all")[0].disabled = false;
		document.getElementsByClassName("mark-none")[0].disabled = true;
		document.getElementsByClassName("mark-none")[1].disabled = true;
	},

	markAll: function(e){
		var listElements = e.currentTarget.parentElement.nextElementSibling.getElementsByClassName("markUser");
		for(var i = 0; i < listElements.length; ++i){
			listElements[i].classList.add("selected");
		}
		var buttonsArray = e.currentTarget.parentElement;
		var addCollaborator = buttonsArray.getElementsByClassName("add-collaborator")[0];
		var removeCollaborator = buttonsArray.getElementsByClassName("rm-collaborator")[0];
		var markNone = buttonsArray.getElementsByClassName("mark-none")[0];
		var markAll = buttonsArray.getElementsByClassName("mark-all")[0];
		if(addCollaborator){
			addCollaborator.disabled = false;
		}
		if(removeCollaborator){
			removeCollaborator.disabled = false;
		}
		markNone.disabled = false;
		if(markAll){
			markAll.disabled = true;
		}
	},

	markNone: function(e){
		var listElements = e.currentTarget.parentElement.nextElementSibling.getElementsByClassName("markUser");
		for(var i = 0; i < listElements.length; ++i){
			listElements[i].classList.remove("selected");
		}
		var buttonsArray = e.currentTarget.parentElement;
		var addCollaborator = buttonsArray.getElementsByClassName("add-collaborator")[0];
		var removeCollaborator = buttonsArray.getElementsByClassName("rm-collaborator")[0];
		var markNone = buttonsArray.getElementsByClassName("mark-none")[0];
		var markAll = buttonsArray.getElementsByClassName("mark-all")[0];
		if(addCollaborator){
			addCollaborator.disabled = true;
		}
		if(removeCollaborator){
			removeCollaborator.disabled = true;
		}
		markNone.disabled = true;
		if(markAll){
			markAll.disabled = false;
		}
	},

	discardfile: function(e){
		if(!e.currentTarget.classList.contains("icon_trash")){
			e.currentTarget.remove();
			var discard = e.currentTarget.id;
			var index;
			if(this.files.length == 0){
				toastr.info(arrlang[lang]['NoFilestodiscard'],"Información");
			}
			else{
				for (var i = 0; i < this.files.length; i++) {
					if(this.files[i]._name == discard){
						index = i;
					}
				}
				this.files.splice(index, 1);
				this.filescont--;
			}
		}
	},

	discardfile3: function(e){
		e.currentTarget.parentElement.remove();
		var discard = e.currentTarget.id;
		var index;
		if(this.adminCommentFiles.length == 0){
				toastr.info(arrlang[lang]['NoFilestodiscard'],"Información");
		}
		else{
			for (var i = 0; i < this.adminCommentFiles.length; i++) {
				if(this.adminCommentFiles[i]._name == discard){
					index = i;
				}
			}
			this.adminCommentFiles.splice(index, 1);
			this.adminCommentFilesCont--;
		}
	},

	SaveFiles: function(e){
		var idx = this.adminoteid;
		if(this.files.length == 0){
			toastr.info(arrlang[lang]['NoFilestosave'],"Información");
		}
		else{
			var that = this;
			toastr.options.timeOut = "0";
			toastr.options.extendedTimeOut = "0";
			var txt = '<span>'+ arrlang[lang]["Filetstosave"] +'</span><br><button class="btntoastr btnaccept" id="'+ adminnote +'">'+ arrlang[lang]["ToastrAccept"] +'</button><button class="btntoastr btncancel">'+ arrlang[lang]["ToastrCancel"] +'</button>';
			this.toastrButtons(txt, 'sucess');
			$('.btnaccept').one("click", function(e){
				that.acceptButtonSaveFiles(e);
			});
			$('.btncancel').one("click", function(){
				that.cancelButtonSaveFiles();
			});
			this.files = [];
		}
		$('#myModal2').hide();
		$('.modal-backdrop').hide();
	},

	acceptButtonSaveFiles: function(e){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		var idx = this.adminoteid;
		for (var i = 0; i < this.files.length; i++) {
			var filex = this.files[i];
			getAdminFileService().createSimpleFile(filex,idx,null);
		}
	},

	cancelButtonSaveFiles: function(){
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		toastr.error(arrlang[lang]["Filetsnotsave"],"");
	},

	filesmodal: function(e){
		var idx = e.target.getAttribute("id").toString();
		this.adminoteid = idx;
		$('.discardreport').empty();
		$('.discardreport').remove();
		this.$el.find('#filesnotest').text(arrlang[lang]['NoteFilestext']+': '+idx);
		if(this.files.length == 0){
			$('.SaveFilesbtn').prop('disabled', true);
		}
		var that = this;
		setTimeout(function(){ that.renderAmdminnotesFiles(); }, 200);
	},

	uploadFile: function(e){
		var namelenght = e.target.files[0].name.length;
		this.filescont++;
		var extension = e.target.files[0].name.substring(namelenght-4, namelenght);
		if (extension.charAt(0) != '.'){
			var extension = e.target.files[0].name.substring(namelenght-5, namelenght);
		}
		var reader = new FileReader();
		var name = 'File_'+this.filescont+extension;
		var that = this;
		var reader = new FileReader();
		$('#filename').fadeIn();
		$('#filename').append("<div class='action remove-report discardreport' id='"+name+"'  title='Descartar archivo'> "+ name +"</div><br><div class='separator2></div>");
		$(".discardreport").hover(function(){
			$(this).css("color", "#2F4F4F ");
			$(this).css("cursor", "pointer");
        },
		function(){
			$(this).css("color", "inherit");
		});
		reader.onload = function (e) {
			var output = that.getFileStream(e.target.result);
			switch(extension){
				case '.pdf':
					var parseFile = new Parse.File(name, output, 'application/pdf');
				break;
				default:
					var parseFile = new Parse.File(name, output);
				break;
			}
			that.files.push(parseFile);
		};
		reader.readAsArrayBuffer(e.target.files[0]);
		$('.SaveFilesbtn').prop('disabled', false);
	},

	uploadFile2: function(e){
		var namelenght = e.target.files[0].name.length;
		this.filescont++;		
		$('#loadfilestext').show();
		$('#loadfilesspin').show();
		var extension = e.target.files[0].name.substring(namelenght-4, namelenght);
		if (extension.charAt(0) != '.'){
			var extension = e.target.files[0].name.substring(namelenght-5, namelenght);
		}
		var that = this;
		var reader = new FileReader();
		var name = 'File_'+this.filescont+extension;
		$('#filenamef').fadeIn();
		$('#filenamef').append("<div class='action remove-report discardreport' id='"+name+"'  title='Descartar archivo'> <i class='fa fa-trash discardreport icon_trash'></i>"+ name +"</div>");
		$(".discardreport").hover(function(){
			if(!$(this).hasClass('icon_trash')){
				$(this).css("color", "#2F4F4F ");
				$(this).css("cursor", "pointer");
				$(this).css("border", "solid 1px");
				$(this).css("border-radius", "5px");
				$('.icon_trash', this).css("display", "inline");
			}
		},
		function(){
			$(this).css("color", "inherit");
			$(this).css("border", "initial");
			$('.icon_trash', this).css("display", "none");
		});
		var checkResize = imageResize.checkImage(extension);
		if(checkResize){
			var returnFunc = function(data){
				var b64Data = data.split('base64,')[1];
				var parseFile = new Parse.File(name, { base64: b64Data }, 'image/png');
				$('#loadfilestext').hide();
				$('#loadfilesspin').hide();
				that.files.push(parseFile);
			};
			reader.onload = function (e) {
				imageResize.resizeImage(e.target.result, returnFunc);
			};
			reader.readAsDataURL(e.target.files[0]);
		}
		else{
			reader.onload = function (e) {
				var output = that.getFileStream(e.target.result);
				switch(extension){
					case '.pdf':
						var parseFile = new Parse.File(name, output, 'application/pdf');
					break;
					default:
						var parseFile = new Parse.File(name, output);
					break;
				}
				
				$('#loadfilestext').hide();
				$('#loadfilesspin').hide();
				that.files.push(parseFile);
			};
			reader.readAsArrayBuffer(e.target.files[0]);
		}
		$('.SaveFilesbtn').prop('disabled', false);
	},

	getFileStream: function(file){
		var byteArray = new Uint8Array(file);
		var output = new Array(byteArray.length);
		var i = 0;
		var n = output.length;
		while (i < n) {
			output[i] = byteArray[i];
			i++;
		}
		return output;
	},

	uploadFile3: function(e){
		var namelenght = e.target.files[0].name.length;
		this.adminCommentFilesCont++;
		var extension = e.target.files[0].name.substring(namelenght-4, namelenght);
		if (extension.charAt(0) != '.'){
			var extension = e.target.files[0].name.substring(namelenght-5, namelenght);
		}
		var that = this;
		var reader = new FileReader();
		var name = 'File_'+(this.adminCommentFilesCont+this.currentReportFilesCount)+extension;
		$('#filename3').fadeIn();
		$('#filename3').append("<div class='action remove-report' '  title='Descartar archivo'> "+ name +"<i class='fa fa-trash discardreport3' id='"+name+"'></i></div><br>");
		$(".discardreport3").hover(function(){
			$(this).css("color", "#2F4F4F ");
			$(this).css("cursor", "pointer");
		},
		function(){
			$(this).css("color", "inherit");
		});
		var checkResize = imageResize.checkImage(extension);
		if(checkResize){
			var returnFunc = function(data){
				var b64Data = data.split('base64,')[1];
				var parseFile = new Parse.File(name, { base64: b64Data }, 'image/png');
				that.adminCommentFiles.push(parseFile);
			};
			reader.onload = function (e) {
				imageResize.resizeImage(e.target.result, returnFunc);
			};
			reader.readAsDataURL(e.target.files[0]);
		}
		else{
			reader.onload = function (e) {
				var output = that.getFileStream(e.target.result);
				switch(extension){
					case '.pdf':
						var parseFile = new Parse.File(name, output, 'application/pdf');
					break;
					default:
						var parseFile = new Parse.File(name, output);
					break;
				}
				that.adminCommentFiles.push(parseFile);
			};
			reader.readAsArrayBuffer(e.target.files[0]);
		}
		$('.SaveFilesbtn').prop('disabled', false);
	},

	priority:function(){
		var id = $('#priorities').val();
		var params = {reportID: this.report[0].id, kind: 'priority', data: parseInt(id)};
		Parse.Cloud.run("SetReport", params).then(() => {
			toastr.success(arrlang[lang]["PriorityReportMessage"],"Operación realizada");
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
				default:
					if(arrlang[lang][error.message]){
						toastr.error(arrlang[lang][error.message], "Error");
					}
					else{
						toastr.error('Reporte no asignado, hubo un problema con la red.', "Error");
					}
				break;
			}
		});
	},

	renderFiles: function(){
		var adminNotesIds = [];
		for(var i = 0; i < this.adminnotes.models.length; ++i){
			adminNotesIds.push(this.adminnotes.models[i].attributes.id);
			this.$el.find('#files-container-'+this.adminnotes.models[i].attributes.id).empty();
		}
		var that = this;
		Parse.Cloud.run('GetAllAdminNoteFiles', { adminNotesIds: adminNotesIds }).then((data) => {
			for(var i = 0; i < data.length; ++i){
				var name = data[i].attributes.File._name;
				var title = name.substr(32,name.length-32);
				var url = data[i].attributes.File._url;
				var re = /(?:\.([^.]+))?$/;
				var ext = re.exec(title.toLowerCase())[1];
				var type = getUtilsService.getFileType(ext);
				var content = '';
				if(type){
					content = "<button type='button'class='btn btn-default item file' data-url='"+url+"' title='"+title+"'>"+title+" </button>";
				}
				else{
					content = "<button type='button'class='btn btn-default item file_download' data-url='"+url+"' title='"+title+"'>"+title+"</button>";
				}
				that.$el.find('#files-container-'+data[i].attributes.AdminNote.id).append(content);
			}
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},


	renderAmdminnotesFiles: function(){
		var idx = this.adminoteid ;
		getAdminFileService().fetch({
			all: true,
			cache: false,
			rules: {
				equals: [{
					key: 'AdminNote',
					val: { __type: "Pointer", className: "AdminNotes", objectId: idx }
				}]
			}
		}).then(files => {
			if (files.models.length > 0) {
				var that = this;
				that.$el.find('#nofiles').fadeIn();
				that.$el.find('#nofiles').text(arrlang[lang]['NoteFilestext'])
				that.$el.find('#files-container2').empty();
				that.$el.find('#files-container2').fadeIn();
				for (var i = 0; i < files.models.length; i++){
					var name = files.models[i].attributes.File._name;
					var title = name.substr(32,name.length-32);
					var url = files.models[i].attributes.File._url;
					var content = "<div class='file' data-url='"+url+"' title='"+title+"'>"+title+" </div>";
					that.$el.find('#files-container2').append(content);
				}
			}
			else{
				var that = this;
				that.$el.find('#files-container2').empty();
				that.$el.find('#nofiles').fadeIn();
				that.$el.find('#nofiles').text(arrlang[lang]['NoFilestoshow']);
			}
		}, (error) => {
			this.$el.html(handlebarsTemplate(null));
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},

	/**
	*
	* @function renderReport
	* @param reportID
	*/
	renderReport: function(reportID) {
		var handlebarsTemplate = Handlebars.template(report_template);
		this.$el.html(handlebarsTemplate());
		this.$el.find('#specific-content').hide();
		var handlebarsTemplateCollaborators = Handlebars.template(collaborators_template);
		var handlebarsTemplateChangeSubCat = Handlebars.template(changesubcat_template);
		var that = this;
		this.$reportDisplay.empty();
		this.reportid = reportID;
		this.userid = Parse.User.current();
		var permissions = getUtilsService.getprofilepermissions();
		var id =  { reportID: reportID,mobile: false};
		if (Settings.shogunmonitorapp && !permissions.accessallreports) {
			id.shogunmonitorapp = true;
		}
		Parse.Cloud.run("GetReport", id).then((reportinfo) => {
			if (reportinfo.permission == false) {
				toastr.warning(arrlang[lang]['warningmessage'],arrlang[lang]['warning']);
				EventHub.trigger('navigate', 'personal', {
					trigger: true
				});
			}
			this.$reportDisplay.html(arrlang[lang]['LoadReport']+' ' + reportID + '...');
			that.report = reportinfo.report;
			that.subCatId = this.report[0].attributes.subCategory.id;
			var options = {
				year: 'numeric',
				month: 'short',
				day: 'numeric'
			};
			var langdate = lang + "-GB";
			var datereport = reportinfo.report[0].attributes.createdAt.toLocaleDateString(langdate, options);
			var reportDate = reportinfo.report[0].attributes.createdAt;
			var currentDate = new Date();
			var differenceInMs = currentDate.getTime() - reportDate.getTime();
			var differenceInDays = Math.floor(differenceInMs / (1000 * 60 * 60 * 24));
			var prorroga = reportinfo.report[0].attributes.deleteReportData == 'SIN PRORROGA';
			var deleted = reportinfo.report[0].attributes.deleteReportData == 'ELIMINADO';
			that.deleted = deleted;
			var adminotes = {};
			adminotes.models = [];
			for (var i = 0; reportinfo.adminnotes && i < reportinfo.adminnotes.length; i++) {
				var dateadminnote = reportinfo.adminnotes[i].attributes.createdAt;
				dateadminnote = dateadminnote.toLocaleDateString('en-GB');
				var auditor = reportinfo.adminnotes[i].attributes.auditor.attributes.username;
				if(auditor == undefined){
					auditor = arrlang[lang]['DeletedUser'];
				}
				//datos nuevos
				var note = reportinfo.adminnotes[i].attributes.note;
				var seeMore = false;
				if(note.length > that.adminNoteLimit){
					note = note.substr(0,728);
					seeMore = true;
				}
				adminotes.models[i] = {
					attributes: {
						createdAt: dateadminnote,
						original: reportinfo.adminnotes[i].attributes.note,
						note: note,
						id: reportinfo.adminnotes[i].id,
						auditor: auditor,
						seeMore: seeMore,
						i: i
					}
				};
			}
			var comments = {};
			comments.models = [];
			for (var i = 0; i < reportinfo.reportcomments.length; i++) {
				options = {
					year: 'numeric',
					month: 'short',
					day: 'numeric',
					hour: 'numeric',
					minute: 'numeric'
				}
				var datecomment = reportinfo.reportcomments[i].attributes.createdAt.toLocaleString(langdate, options);
				var commentstring = reportinfo.reportcomments[i].attributes.comment;
				var commentAuditor = reportinfo.reportcomments[i].attributes.auditor;
				datecomment =  datecomment.toUpperCase();
				var commentid = reportinfo.reportcomments[i].id;
				comments.models[i] = {attributes:{createdAt: datecomment, comment: commentstring, auditor: commentAuditor, commentid: commentid}};
			}
			var usernamestring = reportinfo.report[0].attributes.userName;
			this.adminnotes = adminotes;
			var permissions = getUtilsService.getprofilepermissions();
			var queryPromise = reportinfo.report[0].attributes.collaborators.query().find();
			Parse.Promise.when(queryPromise).then((collaborators) => {
				var notCollaborators = reportinfo.users;
				for(var i = 0; i < collaborators.length; ++i){
					for(var j = 0; j < notCollaborators.length; ++j){
						if(collaborators[i].id == notCollaborators[j].id){
							notCollaborators.splice(j, 1);
						}
					}
				}
				if (Settings.shogunmonitorapp && !permissions.accessallreports) {
					var notcollabs = [];
					var collabs = [];
					for(var x = 0; x < notCollaborators.length; ++x){
						if (notCollaborators[x].attributes.supercategory == that.userid.attributes.supercategory && Settings.shogunmonitorapp && that.userid.attributes.supercategory != undefined) {
							notcollabs.push(notCollaborators[x]);
						}
					}
					for(var i = 0; i < collaborators.length; ++i){
						if (collaborators[i].attributes.supercategory == that.userid.attributes.supercategory && Settings.shogunmonitorapp && that.userid.attributes.supercategory != undefined) {
							collabs.push(collaborators[i]);
						}
					}
					notCollaborators = notcollabs;
					collaborators = collabs;
				}
				var params2 = {
					notCollaborators: notCollaborators,
					collaborators: collaborators,
					deleted: deleted
				};
				$("#collaboratorsModalContainer").append(handlebarsTemplateCollaborators(params2));
				$("#changesubcatModalContainer").append(handlebarsTemplateChangeSubCat());
				$('.collaboratorsloader').hide();
			},
			(error) => {
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
			var isOpen = false;
			if(reportinfo.report[0].attributes.status == 'open'){
				isOpen = true;
			}
			permissions.allowreubicarreports = Settings.allowreubicarreports;
			var params = {
				id: reportID,
				attributes: reportinfo.report[0],
				comments: comments,
				adminnotes: adminotes,
				usernamestring: usernamestring,
				datereport: datereport,
				isOpen: isOpen,
				daysopen: differenceInDays,
				description: reportinfo.report[0].attributes.description,
				supercategory: reportinfo.report[0].attributes.subCategory.attributes.superCat.attributes.name,
				subcategory: reportinfo.report[0].attributes.subCategory.attributes.name,
				prorroga: prorroga,
				deleted: deleted,
				users: reportinfo.users,
				permissions : permissions
			};
			var handlebarsTemplate = Handlebars.template(report_template);
			that.$el.html(handlebarsTemplate(params));
			if (reportinfo.report[0].attributes.customreportvalues != undefined) {
				var handlebarsTemplate = Handlebars.template(customreport_template);
				that.$el.html(handlebarsTemplate(params));
				for (var i = 0; i < reportinfo.report[0].attributes.customreportvalues.customdata.length; i++) {
					var type = reportinfo.report[0].attributes.customreportvalues.customdata[i].type;
					var params = {
						name: reportinfo.report[0].attributes.customreportvalues.customdata[i].name,
						val: reportinfo.report[0].attributes.customreportvalues.customdata[i].val
					};
					var handlebarsTemplate = '';
					if (type == "file") {
						handlebarsTemplate = Handlebars.template(customreportfiles_template);
						var nametrime = params.name.replace(/\s/g, '').replaceAll('(','').replaceAll(')','').replaceAll('.','').replaceAll(',','');
						nametrime = nametrime.slice(0, -1);
						params.nametrim = nametrime;
						if(params.val == null){
							params.val = '';
						}
					}
					else{
						handlebarsTemplate = Handlebars.template(customreportdata_template);
					}
					$("#contentcustomreportdetails").append(handlebarsTemplate(params));
					that.renderfilescustomreport(params, type);
				}
				$("#files-container").hide();
				$("#AttachFilestitle").hide();
			}
			$('.reportdetloader').hide();
			if (reportinfo.reportcomments.length > 0) {
				$('.auditcommentssubtitle').hide();
				$('.div-coment').show();
				$('.commentsubtitle').show();
			}
			var location = '';
			if (reportinfo.report[0].attributes.provincia != undefined && reportinfo.report[0].attributes.provincia != 0 ) {
				$('#reportidtittle').hide();
				$('.subtitleprovincia').text("Provincia: " + reportinfo.report[0].attributes.provincia);
				if (reportinfo.report[0].attributes.canton != undefined && reportinfo.report[0].attributes.canton != '0') {
					$('.subtitlecanton').text("Canton: " + reportinfo.report[0].attributes.canton);
				}
			}
			if (reportinfo.report[0].attributes.comercio != undefined){
				$('.subtitlecomercio').text("Comercio: " + reportinfo.report[0].attributes.comercio);
				$('#reportidtittle').hide();
			}
			if(permissions.readonlyreports){
				$('#admincomment').prop('disabled', true);
				$('#priorities').prop('disabled', true).css('cursor', 'not-allowed');
				$('#workersselect').prop('disabled', true);
				$('#state').prop('disabled', true).css('cursor', 'not-allowed');
			}

			if (!permissions.asignreports) {
				$('#assingcontainer').hide(); 
			}

			if (!permissions.changereportstate) {
				$('#changereportstatecontainer').hide(); 
			}
			
			if (!permissions.relocatereports) {
				$('#relocatereportscontainer').hide(); 
			}

			if (reportinfo.report[0].attributes.priority != undefined) {
					$('#priorities').val(reportinfo.report[0].attributes.priority);
			}
			$('.adminscomment').linkify();
			$('#report-description-view').linkify();
			this.translate();
			$('#state').val(reportinfo.report[0].attributes.status);
			if(Settings.shogunmonitorapp && Parse.User.current().attributes.role != 'Administrador General'){
				$("#timelinecontainer").hide();
			}
			if (reportinfo.reasonsofchangestatus.length == 0) {
				$('#reasontext').hide();
			}
			else{
				$('.Reasonofchangestates').show();
				$('#reasontext').text(reportinfo.reasonsofchangestatus[reportinfo.reasonsofchangestatus.length - 1].attributes.reason);
			}
			
			if(reportinfo.report[0].attributes.deleteReportData == "ELIMINADO"){
				var text = "Denuncia vencida, datos eliminados por: Ley o política de protección de datos.";
				if (reportinfo.reasonsofchangestatus.length == 0) {
					$('#reasontext').show();
					$('#reasontext').text(text); 
					$('.comment-container').hide();
				}else{
					
					$('.Reasonofchangestates').show();
					$('#reasontext').html(reportinfo.reasonsofchangestatus[reportinfo.reasonsofchangestatus.length - 1].attributes.reason+"<br><br>"+text);
					$('.comment-container').hide();
				}				
			}

			that.currentReportFilesCount = reportinfo.reportfiles.length;
			for(var i=0; i< reportinfo.reportfiles.length; ++i){
				var name = reportinfo.reportfiles[i].attributes.file._name;
				var title = name.substr(32,name.length-32);
				var number = name.substr(38,name.length);
				var url = reportinfo.reportfiles[i].attributes.file._url;
				var re = /(?:\.([^.]+))?$/;
				var ext = re.exec(title.toLowerCase())[1];
				var type = getUtilsService.getFileType(ext);

				var splitNumber = number.split(".")[0];
				var intSplitNumber = parseInt(splitNumber);
				intSplitNumber = isNaN(intSplitNumber) ? 0 : intSplitNumber;
				that.currentReportFilesCount = that.currentReportFilesCount < intSplitNumber ? intSplitNumber : that.currentReportFilesCount;

				var content = '';
				if(type){
					content = "<button type='button'class='btn btn-default item file' data-url='"+url+"' title='"+title+"'>"+title+" </button>";
				}
				else{
					content = "<button type='button'class='btn btn-default item file_download' data-url='"+url+"' title='"+title+"'>"+title+"</button>";
				}
				if (reportinfo.reportfiles[i].attributes.comment != undefined) {
					var commentfilecontainer = "#comment-"+  reportinfo.reportfiles[i].attributes.comment.id ;
					$(commentfilecontainer).append(content);
				}else{
					$("#files-container").append(content);
				}
				
			}
			Parse.Cloud.run('UserViewReport', { userID: Parse.User.current().id, reportID: reportID }).then(() => {
				EventHub.trigger('notifMenuLoad');
			},
			(error) => {
				EventHub.trigger('notifMenuLoad');
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},

	renderfilescustomreport: function(params, type){
		if (type == 'file') {
			for (var i = 0; i < params.val.length; i++) {
				var name = params.val[i].url.split("/")[3];
				var title = name.substr(32,name.length-32);
				var url = params.val[i].url;
				var re = /(?:\.([^.]+))?$/;
				var ext = re.exec(title.toLowerCase())[1];
				var type = getUtilsService.getFileType(ext);
				var content = '';
				if(type){
					switch(type) {
						case "image":
							title = 'Imagen.'+ext;
						break;
						case "audio":
							title = 'Video.'+ext;
						break;
						case "video":
							title = 'Audio.'+ext;
						break;
					}
					content = "<button class='btn btn-default item file' data-url='"+url+"' title='"+title+"'>"+title+" </button>";
				}
				else{
					title = 'Archivo.'+ext;
					content = "<button type='button' class='btn btn-default item file_download' data-url='"+url+"' title='"+title+"'>"+title+"</button>";
				}
				$('#'+params.nametrim).append(content)
			}
		}
	},

	downloadFile: function (e){
		var url = $(e.currentTarget).attr('data-url');
		var fileName = $(e.currentTarget).attr('title');
		this.DownloadFile(url, fileName);
	},

	DownloadFile: function (url, fileName) {
		var req = new XMLHttpRequest();
		req.open("GET", url, true);
		req.responseType = "blob";
		req.onload = function () {
			var blob = new Blob([req.response], { type: "application/octetstream" });
			var isIE = false || !!document.documentMode;
			if (isIE) {
				window.navigator.msSaveBlob(blob, fileName);
			}
			else {
				var url = window.URL || window.webkitURL;
				var link = url.createObjectURL(blob);
				var a = document.createElement("a");
				a.setAttribute("download", fileName);
				a.setAttribute("href", link);
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			}
		};
		req.send();
	},

	commentsOpenClose: function() {
		if (this.varcomments === false) {
			this.$el.find('#togglecoments').slideDown('slow');
		}
		else {
			this.$el.find('#togglecoments').slideUp('slow');
		}
		this.varcomments = !this.varcomments;
	},

	/**
	*
	* @function changestatus
	*/
	changestatusfunc: function() {
		$("#modalastatus").modal('show');
	},

	changestatus: function() {
		var report = this.reportid.split("/");
		var status = $('#state').val();
		var reasonofchange = this.$el.find("#textchangestatus").val();
		var that = this;
		if (reasonofchange == ' ') {
			if(status == 'open'){
				var params = {reportID: this.report[0].id, kind: 'status', data:status};
				Parse.Cloud.run("SetReport", params).then(() => {
					toastr.success(arrlang[lang]["SaveStateok"],"Operación realizada");
					that.renderReport(that.reportid);
				},
				(error) => {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
						default:
							if(arrlang[lang][error.message]){
								toastr.error(arrlang[lang][error.message], "Error");
							}
							else{
								toastr.warning(arrlang[lang]['messagetochangestatus3'],"Advertencia");
							}
						break;
					}
				});
			}
			else{
				toastr.warning(arrlang[lang]['messagetochangestatus3'],"Advertencia");
				that.renderReport(that.reportid);
			}
		}
		else{
			var xl = function(result){
				var params = {reportID: that.report[0].id, kind: 'status', data: status, reasonOfChangeStatusID: result.id};
				Parse.Cloud.run("SetReport", params).then(() => {
					toastr.success(arrlang[lang]["SaveStateok"],"Operación realizada");
					that.renderReport(that.reportid);
				},
				(error) => {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
						default:
							if(arrlang[lang][error.message]){
								toastr.error(arrlang[lang][error.message], "Error");
							}
							else{
								toastr.warning(arrlang[lang]['messagetochangestatus3'],"Advertencia");
							}
						break;
					}
				});
			};
			getReasonOfChangeService().setReasonOfChangeStatus({
				__type: "Pointer",
				className: "Report",
				objectId: report
			}, reasonofchange, xl);
		}
	},

	savecomment: function() {
		var that = this;
		var comentario = this.$el.find('#admincomment').val();
		var langdate = lang + "-GB";
		var options = {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
			hour: 'numeric',
			minute: 'numeric'
		}
		var xlf = function(){
			var comment= window.createCommentResponse;
			var createdAt = comment.attributes.createdAt.toLocaleString(langdate, options).toUpperCase();
			var commentHTML = '<li><div class="img-user-coment"><b><span class="item" key="AdminRole">Administrador</span>:</b></div><div class="coment responsive"><span class="adminscomment">'+comment.attributes.comment+'.</span><span class="datecomment">'+ createdAt+'.</span></div>	<div class="commentfilescontainer" id=comment-'+comment.id+'></div><div class="separator2"></div></li>';
			$('#comment-container').prepend(commentHTML);
			$('#admincomment').val('');
			toastr.success("Comentario realizado satisfactoriamente","Operación realizada");
			$('.auditcommentssubtitle').hide();
			$('.div-coment').show();
			$('.commentsubtitle').show();
			that.SaveFiles3(that.reportid,comment.id);
			$('.adminscomment').linkify();
		};
		if(comentario != ''){
			getReportCommentsService().setInternComment({
				__type: "Pointer",
				className: "Report",
				objectId: this.reportid,
			}, this.userid, comentario, xlf);
		}
	},

	SaveFiles3: function(idw,idcomment) {
		var that = this;
		if(this.adminCommentFilesCont > 0){
			$('#loadfilestext3').show();
			$('#loadfilesspin3').show();
			var count = this.adminCommentFilesCont;
			for(var i = 0; i < count; ++i){
				var filex = that.adminCommentFiles[i];
				getReportCommentsFileService().createSimpleFile(filex, idw,idcomment, (files, successful) => {
					--that.adminCommentFilesCont;
					that.currentReportFilesCount++;
					if(that.adminCommentFilesCont == 0){
						$('#loadfilestext3').hide();
						$('#loadfilesspin3').hide();
						that.adminCommentFiles= [];
						$('#filename3').html('');
					}

					if(successful){
						var name = files.attributes.file._name;
						var title = name.substr(32,name.length-32);
						var url = files.attributes.file._url;
						var re = /(?:\.([^.]+))?$/;
						var ext = re.exec(title.toLowerCase())[1];
						var type = getUtilsService.getFileType(ext);
						var content = '';
						if(type){
							content = "<button type='button'class='btn btn-default item file' data-url='"+url+"' title='"+title+"'>"+title+" </button>";
						}
						else{
							content = "<button type='button'class='btn btn-default item file_download' data-url='"+url+"' title='"+title+"'>"+title+"</button>";
						}
						var commentfilecontainer = "#comment-" + idcomment;
						$(commentfilecontainer).append(content);
						if(that.adminCommentFilesCont == 1){
							that.adminCommentFilesCont = 0;
							$('#loadfilestext3').hide();
							$('#loadfilesspin3').hide();
							that.adminCommentFiles= [];
							$('#filename3').html('');
						}
						else{
							--that.adminCommentFilesCont;
						}
						that.currentReportFilesCount++;
						toastr.success("Archivo subido satisfactoriamente","Operación realizada");
					}
				});
			}
			this.adminCommentFiles = [];
		}
	},

	previsual: function (e){
		var preview = new PrevisualView({file: e.currentTarget.getAttribute("data-url"), title: e.currentTarget.title});
		this.$el.find('#preview').empty();
		this.$el.find('#preview').append(preview.el);
		preview.render();
	},

	saveadminnote: function() {
		var adminnote = this.$el.find('#text-adminnote').val();
		if (adminnote == '') {
			toastr.info('Escriba algo para crear una nueva nota.','Información');
		}
		else{
			if (this.files == 0){
				var that = this;
				var xl = function(adminNote){
					that.loadAdminNote(adminNote);
				};
				getAdminNoteService().setAdminNote({
					__type: "Pointer",
					className: "Report",
					objectId: this.reportid,
				}, this.userid, adminnote, xl);
			}
			else{
				$(".toast-success").remove();
				var that = this;
				toastr.options.timeOut = "0";
				toastr.options.extendedTimeOut = "0";
				var txt = '<span>'+ arrlang[lang]["Filetstosave"] +'</span><br><button class="btntoastr btnaccept" id="'+ adminnote +'">'+ arrlang[lang]["ToastrAccept"] +'</button><button class="btntoastr btncancel">'+ arrlang[lang]["ToastrCancel"] +'</button>';
				this.toastrButtons(txt, 'sucess');
				$('.btnaccept').one("click", function(e){
					that.acceptButtonAdminNoteFile(e);
				});
				$('.btncancel').one("click", function(){
					that.cancelButtonAdminNoteFile();
				});
			}
		}
	},

	acceptButtonAdminNoteFile: function(e){
		var that = this;
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		var adminnote = $(e.currentTarget).attr('id');
		$('#loadfilestext').show();
		$('#loadfilesspin').show();
		var xl = function(adminNote){
			var idw ;
			setTimeout(function(){ idw = window.localStorage.adminnoteid; }, 1000);
			setTimeout(function(){ if (that.files.length > 0 ) {that.SaveFiles2(idw);} }, 1550);
			that.loadAdminNote(adminNote);
		};
		getAdminNoteService().setAdminNote({
			__type: "Pointer",
			className: "Report",
			objectId: this.reportid,
		}, this.userid, adminnote, xl);
	},

	cancelButtonAdminNoteFile: function(){
		this.files = [];
		toastr.options.timeOut = "5000";
		toastr.options.extendedTimeOut = "1000";
		this.renderReport(this.reportid);
		$('#myModal').hide();
		$('.modal-backdrop').hide();
		this.renderReport(this.reportid);
	},

	loadAdminNote: function(adminNote){
		toastr.success("Nota de Auditor realizada satisfactoriamente", "Operación realizada");
		var dateadminnote = adminNote.attributes.createdAt;
		dateadminnote = dateadminnote.toLocaleDateString('en-GB');
		var auditor = adminNote.attributes.auditor.attributes.username;
		if(auditor == undefined){
			auditor = arrlang[lang]['DeletedUser'];
		}
		var note = adminNote.attributes.note;
		var seeMore = false;
		if(note.length > this.adminNoteLimit){
			note = note.substr(0,728);
			seeMore = true;
		}
		var adminNoteData = {
			attributes: {
				createdAt: dateadminnote,
				original: adminNote.attributes.note,
				note: note,
				id: adminNote.id,
				auditor: auditor,
				seeMore: seeMore,
				i: 0
			}
		};
		this.adminnotes.models.unshift(adminNoteData);
		for(var i = 0; i < this.adminnotes.models.length; ++i){
			this.adminnotes.models[i].attributes.i = i;
		}
		var adminNoteHtml = '<div class="adminnote-info"><h2 class="adminnote-auditor"> <i class="fa fa-user" aria-hidden="true"></i> <span>'+ adminNoteData.attributes.auditor +'</span> <span class="adminnotedate">'+ adminNoteData.attributes.createdAt +'</span> </h2><h2 class="adminnote-data">'+ adminNoteData.attributes.note +'</h2>';
		if(adminNoteData.attributes.seeMore){
			adminNoteHtml += '<h2 class="see-more" key="AdminNoteSeeMore" id="adminNoteIn-'+ adminNoteData.attributes.i +'">Ver más</h2>';
		}
		adminNoteHtml += '</div><div class="files-container" id="files-container-'+ adminNoteData.attributes.id +'"></div><div class="line-separator"></div><br><br>';
		$('#myModal .modal-body').html(adminNoteHtml+ $('#myModal .modal-body').html());
		this.clearAdminNoteText();
	},

	SaveFiles2: function(idw){
		var idx = idw;
		$('#loadfilestext').show();
		$('#loadfilesspin').show();
		var that = this;
		var len = this.files.length;
		this.fileIndex = 0;
		var xl = function(){
			if (that.fileIndex == len-1) {
				console.log('test');
				that.renderFiles();
				that.clearAdminNoteText();
				that.clearAdminNoteFiles();
				$('#loadfilestext').hide();
				$('#loadfilesspin').hide();
				toastr.success("Nota de Auditor realizada satisfactoriamente","Operación realizada");
			}
			else{
				that.fileIndex++;
			}
		};
		if(this.files.length == 0){
			toastr.info('No hay archivos para guardar',"Información");
		}
		else{
			for (var i = 0; i < this.files.length; i++) {
				var filex = this.files[i];
				getAdminFileService().createSimpleFile(filex, idx, xl);
			}
			this.files=[];
		}
	},

	showCompleteAdminNote: function(e){
		var id = $(e.currentTarget).attr('id').split('-')[1];
		e.currentTarget.parentElement.getElementsByClassName("adminnote-data")[0].innerHTML = this.adminnotes.models[id].attributes.original;
		$(e.currentTarget).hide();
	},

	clearAdminNoteText: function(){
		$('#text-adminnote').val('');
		$('#newfiles').prop('disabled', true);
		$('#saveadminnote').prop('disabled', true);
	},

	clearAdminNoteFiles: function(){
		this.files = [];
		this.filescont = 0;
		$('#upload2').val('');
		$('#filenamef').html('');
		$('#filenamef').fadeOut();
	},

	clearAdminNoteModal: function(){
		this.clearAdminNoteText();
		this.clearAdminNoteFiles();
	}
});
export default ReportView;
